import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  copyMessage: {
    backgroundColor: '#FDF5E6',
  },
}));

export default styles;
